import { Record } from "immutable";

export const customAddressFromJSON = (
  json: Partial<IDabellaCustomFormCustomAddressData>,
): DabellaCustomFormCustomAddressRecord => {
  const data: IDabellaCustomFormCustomAddressRecord = { ...(json as any) };

  return new DabellaCustomFormCustomAddressRecord(data);
};

export const customAddressToJSON = (
  record: DabellaCustomFormCustomAddressRecord,
  kind: "physical" | "mailing" | "co_applicant_physical",
): IDabellaCustomFormCustomAddressData => {
  const customAddress = record.toJS() as any;

  if (kind === "physical") {
    delete customAddress.same_as_applicant;
    delete customAddress.same_as_physical;
  }

  if (kind === "mailing") {
    delete customAddress.same_as_applicant;
  }

  if (kind === "co_applicant_physical") {
    delete customAddress.same_as_physical;
  }

  return customAddress;
};

export interface IDabellaCustomFormCustomAddressData {
  same_as_physical: boolean;
  same_as_applicant: boolean;
  line_1: string;
  line_2: string;
  city: string;
  state: string;
  postal_code: string;
}

export interface IDabellaCustomFormCustomAddressRecord {
  same_as_physical: boolean;
  same_as_applicant: boolean;
  line_1: string;
  line_2: string;
  city: string;
  state: string;
  postal_code: string;
}

const defaultCustomAddressProps: IDabellaCustomFormCustomAddressRecord = {
  same_as_physical: false,
  same_as_applicant: false,
  line_1: "",
  line_2: "",
  city: "",
  state: "",
  postal_code: "",
};

export class DabellaCustomFormCustomAddressRecord
  extends Record(defaultCustomAddressProps)
  implements IDabellaCustomFormCustomAddressRecord {}
